export function renderCanvasFingerprint(): string {
  const canvas = document.createElement('canvas');
  canvas.width = 280;
  canvas.height = 80;
  const ctx = canvas.getContext('2d');
  if (!ctx) return '';

  ctx.textBaseline = 'top';
  ctx.font = '14px "Arial"';
  ctx.fillStyle = '#f60';
  ctx.fillRect(0, 0, 280, 20);
  ctx.fillStyle = '#069';
  ctx.fillText('TrustCaptcha — fingerprint 0123456789', 2, 2);
  ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
  ctx.fillText('TrustCaptcha — fingerprint 0123456789', 4, 22);

  ctx.font = '18px "Times New Roman"';
  ctx.fillStyle = '#000';
  ctx.fillText('Cwm fjordbank glyphs vext quiz 😀', 2, 40);

  ctx.globalCompositeOperation = 'multiply';
  for (const [color, x, y] of [['rgb(255,0,255)', 50, 60], ['rgb(0,255,255)', 80, 60], ['rgb(255,255,0)', 65, 75]] as const) {
    ctx.fillStyle = color;
    ctx.beginPath();
    ctx.arc(x, y, 18, 0, Math.PI * 2, true);
    ctx.closePath();
    ctx.fill();
  }

  ctx.globalCompositeOperation = 'source-over';
  ctx.strokeStyle = '#3b82f6';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(120, 70);
  ctx.bezierCurveTo(160, 30, 200, 90, 260, 50);
  ctx.stroke();

  return canvas.toDataURL();
}
